import React from "react";

import img1 from "../images/AIIMS.jpg";
import img2 from "../images/INDIAN RAILWAYA.jpg";
import img3 from "../images/CPWD.jpg";
import img4 from "../images/NHAI.jpg";
import img5 from "../images/BHEL.jpg";
import img6 from "../images/dm.jpg";
import img7 from "../images/PUBLIC WORKS DEPERTMENT.jpg";
import img8 from "../images/BSF.jpg";
import img9 from "../images/LT.jpg";
import img10 from "../images/RELIANCE.jpg";
import img11 from "../images/INDIAN OIL.jpg";
import img12 from "../images/BHARAT PETROLEOM.jpg";
import img13 from "../images/HP.jpg";
import img14 from "../images/JIO BP.jpg";
import img15 from "../images/SBI BANK.jpg";
import img16 from "../images/CANARA B.jpg";
import img17 from "../images/PNB LOGO.jpg";
import img18 from "../images/AXIX BANK.jpg";
import img19 from "../images/UCO.jpg";

const clients = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
   img14,
  img15,
  img16,
  img17,
   img18,
    img19,
    
];

function ClientSlider() {
  return (
    <section className="py-4 color overflow-hidden">
      <div className="container">
        <h2 className="text-center mb-4"><b>Our Clients</b></h2>

        <div className="slidernew">
          <div className="slidenew-track">
            {[...clients, ...clients].map((logo, index) => (
              <div className="slidenew" key={index}>
                <img
                  src={logo}
                  alt={`Client ${index + 1}`}
                  className="client-logo"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      
    </section>
  );
}

export default ClientSlider;